import styled, { css } from 'styled-components';
import { Flexbox, Text } from '@morressier/ts';
import { RadioButton } from 'components/ProfileUIComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '../styles';

export const Container = styled(Flexbox)<{
  isCareerStage: boolean;
}>`
  ${({ isCareerStage }) =>
    !isCareerStage
      ? css`
          padding: 1rem;
          border: 1px solid var(--color-mono-95);
          border-radius: 8px;
        `
      : css``}
`;

export const MissingCareerStageIcon = styled(FontAwesomeIcon)`
  font-size: var(--fontSizes-xxl);
  line-height: var(--lineHeights-l);
  color: var(--color-teal-40);
`;

export const InfoIcon = styled(FontAwesomeIcon)`
  color: var(--color-mono-60);
  cursor: pointer;
`;

export const Actions = styled.div`
  margin-top: 8px;
`;

export const FormContainer = styled(Flexbox)`
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

export const SecondaryText = styled(Text)`
  color: var(--color-mono-60);
`;

export const Radio = styled(RadioButton)`
  label {
    border-radius: 0.25rem;
  }
`;

export const CareerStageTooltip = styled(Tooltip)`
  &::before {
    width: 17rem;
    left: -8rem;
    top: -4rem;
  }
  &:after {
    left: 8px;
    top: -12px;
    box-shadow: 4px 4px 4px rgb(0 0 0 / 16%);
  }
`;

export const Heading = styled(Text)`
  margin-bottom: 1rem;
`;
